import { AppError } from '@/domain/errors/app-error'

/**
 * Representa uma falha em que a request não obteve resposta HTTP
 * (rede/CORS/timeout ou bloqueio por um intermediário, ex.: proxy corporativo).
 *
 * Vive em `infra/http` (não em `domain/`, que é congelado): é um erro de
 * infraestrutura/transporte, lançado a partir da camada HTTP. Estende AppError
 * apenas para herdar `customError` e a semântica de erro de aplicação.
 *
 * Por ser AppError (customError), não cai na mensagem genérica "HTTP undefined".
 * A mensagem exibida ao usuário é resolvida via i18n na camada de apresentação
 * (ver resolveErrorMessage). MESSAGE é apenas um fallback técnico (não-i18n).
 *
 * IMPORTANTE: não adicionar 'NetworkError' a IGNORED_ERROR_NAMES — queremos
 * mantê-lo observável no Sentry (tag dedicada, ver query-client).
 */
export class NetworkError extends AppError {
  private static NAME: string = 'NetworkError'
  private static MESSAGE: string = 'Network connection failed. No response received.'

  constructor(
    message?: string | null,
    public readonly correlationId?: string,
    /** URL da request que falhou — contexto de observabilidade. */
    public readonly requestUrl?: string
  ) {
    super(NetworkError.NAME, message ?? NetworkError.MESSAGE)
  }
}
